(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo-table-components/tipsinfo-table.js') >= 0) return;  svs.modules.push('/components/tipsen/tipsinfo/assets/javascripts/tipsinfo-table-components/tipsinfo-table.js');
"use strict";

const {
  clx
} = svs.components.lbUtils;
const {
  TableBody,
  TableHeader
} = svs.components.tipsen.tipsinfo.tableComponents;
const TableComponent = _ref => {
  let {
    ariaDescription,
    branding,
    children,
    className
  } = _ref;
  return React.createElement("table", {
    className: clx('tipsinfo_table', className, {
      ["tipsinfo_table--".concat(branding)]: branding
    })
  }, ariaDescription && React.createElement("caption", {
    className: "sr-only"
  }, ariaDescription), children);
};
TableComponent.Body = TableBody;
TableComponent.Header = TableHeader;
setGlobal('svs.components.tipsen.tipsinfo.tableComponents.TableComponent', TableComponent);

 })(window);